// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__3f-DD","list":"PatternAutocomplete_list__9Ar-v"};